const calculateTds = (totalAmount, tdsPercent) => {
  const tds = (tdsPercent / 100) * totalAmount;
  return Number(tds).toFixed(2);
};

export default calculateTds;
